import SummitNationalData from "../../../../src/components/summit-national-data.js";
import * as React from 'react';
export default {
  SummitNationalData,
  React
};